import styled from 'foundations-theming/utils';
import { devices } from '../../styles/viewports.styles';
export const StyledWave = styled.div.withConfig({
  displayName: "Wavestyles__StyledWave",
  componentId: "sc-13h0bb-0"
})([".Wave{display:none;}@media ", "{.Wave{display:block;position:fixed;bottom:0;left:0;width:100%;max-height:35%;z-index:-1;isolation:isolate;}.Wave__Wrapper{svg{display:initial;}}path{transition:all 20s ease;}.ErrorWave{background:", ";}.OrangeWave{height:55%;max-height:70%;background:", ";}.LowOrangeWave{background:", ";max-height:23%;}}"], devices.desktop, ({
  theme
}) => theme.color['fill-accent-purple-subtle-alt'], ({
  theme
}) => theme.color['fill-accent-orange-subtle-alt'], ({
  theme
}) => theme.color['fill-accent-light-orange-subtle-alt']);